import React, { useState, useEffect } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import { CSVLink } from "react-csv";
import { useNavigate } from "react-router-dom";



const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;


const SearchUser = () => {
    const [mobileno, setMobileno] = useState("");
    const [userid, setUserid] = useState("");
    const [username, setUsername] = useState("");
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [userDetails, setUserDetails] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
                      const [expandedPlanIndex, setExpandedPlanIndex] = useState(null);
    


                    const navigate = useNavigate();
    


   useEffect(() => {
         document.title = 'Search User - Calendar Services';
             }, []);

    const fetchData = async () => {
        setLoading(true);
        try {
            // const response = await axios.get("http://localhost:3036/search_user", {
                const response = await axios.get(`${API_BASE_URL}/search_user`,{ 

                params: { mobileno, userid, username },
            });
            setData(response.data);
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setLoading(false);
        }
    };


    const handleViewDetails = async (userid) => {
        setLoading(true);
        try {
            // const response = await axios.post("http://localhost:3036/registered_users/details_userid", { id: userid });
            const response = await axios.post(`${API_BASE_URL}/registered_users/details_for_search`, { id: userid });

            setUserDetails(response.data);
            setIsModalOpen(true);
        } catch (error) {
            console.error("Error fetching user details:", error);
            alert("Failed to fetch user details.");
        } finally {
            setLoading(false);
        }
    };

    const handlePlanClick = (index) => {
        setExpandedPlanIndex(expandedPlanIndex === index ? null : index);
      };

    // const handleEditUser = async (row) => {
    //     try {
    //         const payload = row.userid ? { userid: row.userid } : { name: row.name, type: row.type };
    
    //         const response = await axios.post(`${API_BASE_URL}/registered_users/details_name_type`, payload);
    
    //         // Navigate to the RegisterUser page with the fetched user details
    //         navigate("/master/update_user", { state: { userDetails: response.data } });
    //     } catch (error) {
    //         console.error("Error fetching user details:", error);
    //         alert("Failed to fetch user details.");
    //     }
    // };


    

const handleEditUser = async () => {
    try {
      if (!userDetails) {
        alert("No user details available for editing.");
        return;
      }
  
      const response = await axios.post(`${API_BASE_URL}/registered_users/details_name_type`, {
        userid: userDetails.id, // Ensure correct ID is passed
      });
  
      // Navigate to update page with fetched user details
      navigate("/master/update_user", { state: { userDetails: response.data } });
    } catch (error) {
      console.error("Error fetching user details:", error);
      alert("Failed to fetch user details.");
    }
  };

    const closeModal = () => {
        setIsModalOpen(false);
        setUserDetails(null);
    };

    const columns = [
        { name: "SlNo", selector: (row) => row.slNo, sortable: true },
      {
                    name: "Actions",
                    cell: (row) => (
                        <button
                            onClick={() => handleViewDetails(row.userid)}
                            className="btn btn-warning bg-red-200"
                        >
                            View Details
                        </button>
                    ),
                },

     { name: "KYC Status", selector: (row) => row.kycStatus, sortable: true }, // KYC Status column
        { name: "User ID", selector: (row) => row.userid, sortable: true }, // Add User ID column
        { name: "Name", selector: (row) => row.name, sortable: true },
        { name: "Mobile No", selector: (row) => row.mobileno, sortable: true },
        { 
            name: "Type", 
            selector: (row) => row.type, 
            cell: (row) => (
                <span
                    style={{
                        background: row.typeColor,
                        padding: "5px",
                        color: "#fff",
                        borderRadius: "4px",
                    }}
                >
                    {row.type}
                </span>
            ),
            sortable: true,
        },
        { name: "District", selector: (row) => row.district, sortable: true }, // Updated to fetch district names
        { name: "City", selector: (row) => row.city, sortable: true },
        { name: "View Count", selector: (row) => row.viewcount, sortable: true },
        { name: "Call Count", selector: (row) => row.callcount, sortable: true },
        { name: "Registered Date", selector: (row) => row.cdate, sortable: true },
        { name: "cby", selector: (row) => row.cby, sortable: true },

    ];



    const csvHeaders = [
        { label: "SlNo", key: "slNo" },
        { label: "KYC Status", key: "kycStatus" },
        { label: "User ID", key: "userid" },
        { label: "Name", key: "name" },
        { label: "Mobile No", key: "mobileno" },
        { label: "Type", key: "type" },
        { label: "District", key: "district" },
        { label: "City", key: "city" },
        { label: "View Count", key: "viewcount" },
        { label: "Call Count", key: "callcount" },
        { label: "Registered Date", key: "cdate" },
    ];



    return (
        <div className="max-w-6xl mx-auto mt-8 bg-white">
            <h2 className="text-2xl font-bold mb-6 text-center text-blue-700">Search User</h2>
            <div className="flex justify-center items-center gap-6 mb-6">
                <div className="flex flex-col items-center">
                    <label htmlFor="mobileno" className="mb-1 font-medium">
                        Mobile No:
                    </label>
                    <input
                        type="text"
                        id="mobileno"
                        value={mobileno}
                        onChange={(e) => setMobileno(e.target.value)}
                        className="border border-gray-300 rounded-md p-2"
                    />
                </div>
                <div className="flex flex-col items-center">
                    <label htmlFor="userid" className="mb-1 font-medium">
                        User ID:
                    </label>
                    <input
                        type="text"
                        id="userid"
                        value={userid}
                        onChange={(e) => setUserid(e.target.value)}
                        className="border border-gray-300 rounded-md p-2"
                    />
                </div>
                <div className="flex flex-col items-center">
                    <label htmlFor="username" className="mb-1 font-medium">
                        User Name:
                    </label>
                    <input
                        type="text"
                        id="username"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        className="border border-gray-300 rounded-md p-2"
                    />
                </div>
                <button
                    onClick={fetchData}
                    className="bg-blue-500 text-white px-4 py-2 rounded-md"
                >
                    Search
                </button>
            </div>

            <div className="flex justify-end mb-5">
                <CSVLink
                    data={data}
                    headers={csvHeaders}
                    filename="search_list.csv"
                    className="bg-green-500 text-white px-4 py-2 rounded-md"
                >
                    Export to Excel
                </CSVLink>
            </div>


            <DataTable
                columns={columns}
                data={data}
                progressPending={loading}
                pagination
                highlightOnHover
            />
                   {isModalOpen && userDetails && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
            <div
                className="bg-white p-6 rounded-lg max-w-4xl w-full overflow-y-auto"
                style={{ maxHeight: "80vh" }}
            >
                <h3 className="text-xl font-bold mb-4 text-center text-blue-700">User Details</h3>
                <div className="grid grid-cols-2 gap-4">
                    <p><strong>Name:</strong> {userDetails.name}</p>
                    <p><strong>Mobile No:</strong> <span style={{ color: "green" }}>{userDetails.mobileNo}</span></p>
                    <p><strong>Gender:</strong> {userDetails.gender || "-"}</p>
                    <p><strong>Type:</strong> {userDetails.type}</p>
                    <p><strong>Category:</strong> {userDetails.category || "-"}</p>
                    <p><strong>District:</strong> {userDetails.district}</p>
                    <p><strong>City:</strong> {userDetails.city}</p>
                    <p><strong>Education:</strong> {userDetails.education}</p>
                    <p><strong>Experience:</strong> {userDetails.experience} years</p>
                    <p><strong>Address:</strong> {userDetails.address || "-"}</p>
                    {/* <p><strong>E-mail:</strong> {userDetails.email || "-"}</p> */}
                    <p><strong>Other Details:</strong> {userDetails.other_details || "-"}</p>
                    <p><strong>Web Link:</strong> <a href={userDetails.webLink} target="_blank" rel="noopener noreferrer">{userDetails.webLink}</a></p>
                    <p><strong>YouTube Link:</strong> <a href={userDetails.youtubeLink} target="_blank" rel="noopener noreferrer">{userDetails.youtubeLink}</a></p>
                    <p><strong>Facebook Link:</strong> <a href={userDetails.facebookLink} target="_blank" rel="noopener noreferrer">{userDetails.facebookLink}</a></p>
                </div>
                <div className="mt-4 grid grid-cols-2 gap-4">
                    
                    <div>
                        
                        <strong>Image 1:</strong>
                        {userDetails.image1 && (
                            <img
                                src={userDetails.image1}
                                alt=""
                                className="w-40 h-40 object-cover"
                            />
                        )}
                    </div>
                    <div>
                        <strong>Image 2:</strong>
                        {userDetails.image2 && (
                            <img
                                src={userDetails.image2}
                                alt=""
                                className="w-40 h-40 object-cover"
                            />
                        )}
                    </div>
                    <div>
                        <strong>ID proof</strong>
                        {userDetails.idproof && (
                            <img
                                src={userDetails.idproof}
                                alt=""
                                className="w-40 h-40 object-cover"
                            />
                        )}
                    </div>
                    <div>
                        <strong>Address Proof</strong>
                        {userDetails.addressproof && (
                            <img
                                src={userDetails.addressproof}
                                alt=""
                                className="w-40 h-40 object-cover"
                            />
                        )}
                    </div>
                    <div>
                        <strong>Other Proof</strong>
                        {userDetails.otherproof && (
                            <img
                                src={userDetails.otherproof}
                                alt=""
                                className="w-40 h-40 object-cover"
                            />
                        )}
                    </div>
                </div>

                <div className="mt-4">
      <h2 className="text-xl font-bold mb-4">Plans</h2>
      {userDetails.plans && userDetails.plans.length > 0 ? (
        userDetails.plans.map((plan, index) => (
          <div
            key={index}
            onClick={() => handlePlanClick(index)} // Click handler on the card
            className={`border border-gray-300 rounded-lg shadow-lg p-4 mb-4 cursor-pointer ${
              expandedPlanIndex === index ? "bg-gray-100" : "bg-white"
            }`} // Styling for active and inactive cards
          >
            {/* Card Header */}
            <div className="flex justify-between items-center">
              <h3 className="text-lg font-semibold">{plan.name}</h3>
              <button
  className="text-blue-500 underline"
  onClick={(e) => {
    e.stopPropagation(); // Prevent card click from triggering
    const userId = plan.userId || userDetails.id; // Ensure userId is correctly assigned
    if (userId) {
      window.open(`${API_BASE_URL}/generate_invoice/${userId}`, "_blank"); // Open in a new tab
    } else {
      alert("User ID is missing. Unable to generate invoice.");
    }
  }}
>
  Invoice PDF
</button>

            </div>

            {/* Card Details */}
            {expandedPlanIndex === index && (
              <div className="mt-4">
                <div className="flex justify-between">
                  <p>
                    <strong>Start Date:</strong> {plan.startDate}
                  </p>
                  <p>
                    <strong>End Date:</strong> {plan.endDate}
                  </p>
                </div>
                <p className="mt-2">
                  <strong>Invoice Number:</strong> {plan.invoiceNumber}
                </p>
                <div className="mt-4 border-t border-gray-200 pt-4">
                  <p>
                    <strong>Actual Amount:</strong> ₹{plan.actualAmount} /-
                  </p>
                  <p>
                    <strong>GST Amount (18%):</strong> ₹{plan.gstAmount} /-
                  </p>
                  <p>
                    <strong>Total Amount:</strong> ₹{plan.totalAmount} /-
                  </p>
                </div>
              </div>
            )}
          </div>
        ))
      ) : (
        <p>No plans available</p>
      )}
    </div>

                <div className="mt-6 text-center">
                <button
    onClick={() => handleEditUser(userDetails)}
    className="btn text-white"
    style={{ backgroundColor: "#007bff", margin: "0 0.5rem", padding: "0.5rem 1rem" }}
>
    Edit
</button>


                </div>

                <div className="mt-4 text-center">
                    <button onClick={closeModal} className="btn btn-secondary text-red-500">Close</button>
                </div>
            </div>
        </div>
    )}
        </div>
    );
};

export default SearchUser;
